import React, { Component } from 'react';
import SmallSlideShow from './SmallSlideShow'
import QuoteGenerator from './QuoteGenerator';
  
export class Home extends Component {
  static displayName = Home.name;

  render() {
    return (
          <div className="container-fluid">
            <div className="row">
                <div className="col-lg-5">
                    <SmallSlideShow albumId="3"></SmallSlideShow></div>
                <div className="col-lg-4">
               
                    <h3>Welcome</h3>
                    <p>Hello I'm Ralph Donato.  Welcome to my home page.  </p>
                </div>
                <div className="col-lg-3">
                     
                    <p>&nbsp;</p>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-12">
                &nbsp;
</div></div>




            <div className="row">
                <div className="col-lg-5">
                    <h4>WHATS NEW</h4>
                <p>new etc...  Check back often</p>
                </div>
                <div className="col-lg-7">
                    <h4>Quote of the day</h4>
                    <p>Just some of my favorite quotes randomized</p>
                    <QuoteGenerator />
                </div>
            </div>
        </div>
    );
  }
}
